<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
              <p class="text-h4 text--primary">
                  <TextHeading :level=3>Nasze audyty i kontrole</TextHeading>
              </p>
              <span v-for="(paragraph, i) in paragraphs"
                    :key="i">
                    <p class="text--primary">
                        <TextHeading :level=5>{{ paragraph.title }}</TextHeading>
                    </p>
                    <span v-for="(section, j) in paragraph.sections" :key="j">
                        <div v-if="section.type == 'paragraph'" :id="section.cssId" class="text-body-1 text--primary" v-html="section.text"></div>
                        <p v-if="section.type == 'special_paragraph'" class="text--primary">
                            <TextHeading :level=6>{{ section.text }}</TextHeading>
                        </p>
                        <span v-if="section.type == 'list'">
                            <div class="text-body-1 text--primary" :id="section.cssId" v-html="section.text"></div>
                            <v-list dense disabled>
                                <v-list-item
                                    v-for="(point, k) in section.points"
                                    :key="k"
                                >
                                    <v-list-item-icon>
                                        <v-icon>{{ section.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title ><span class="text-wrap text-body-1" v-html="point"></span></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </span>
                        <br />
                    </span>
                </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},
  
    data: () => ({
      paragraphs: [
        {
            title: "",
            sections: [
                {
                    text: "W Centrum Rozwoju Administracji Sp. z o.o. przeprowadzamy kompleksowe kontrole i audyty projektów unijnych, upewniając się, że przedsięwzięcie, do którego realizacji zostały zaangażowane środki publiczne, przebiega zgodnie z obowiązującymi przepisami oraz zawartymi umowami i wnioskiem o dofinansowanie. Każdego roku przeprowadzamy ok 100 audytów i kontroli na zlecenie Instytucji Pośredniczących i Zarządzających. Specjalnie dla Ciebie przygotowaliśmy listę Instytucji, z którymi zawarliśmy umowy na przeprowadzenie kontroli projektów współfinansowanych ze środków Unii Europejskiej:",
                    type: "list",
                    icon: "mdi-circle-medium",
                    points: [
                      "Kancelaria Prezesa Rady Ministrów w Warszawie - na podstawie umowy nr 396/DOB/2022 z dnia 12.05.2022 r. przeprowadziliśmy 5 kontroli projektów współfinansowanych ze środków Unii Europejskiej.",
                      "Fundacja Orange w Warszawie - na podstawie umowy nr U/28/FO/POPC/2021 z dnia 22.03.2021 r. przeprowadziliśmy 24 kontrole projektów grantowych, współfinansowanych ze środków Unii Europejskiej.",
                      "Ministerstwo Zdrowia w Warszawie - na podstawie umowy nr FGZ.270.8.2017.AR/I z dnia 08.02.2019 r. przeprowadziliśmy 6 wizyt monitoringowych oraz 50 kontroli projektów współfinansowanych ze środków Unii Europejskiej.",
                      "Ministerstwo Zdrowia w Warszawie - na podstawie umowy nr FGZ.270.8.2017.AR/I z dnia 08.02.2019 r. przeprowadziliśmy 42 kontrole projektów współfinansowanych ze środków Unii Europejskiej.",
                      "Ministerstwo Zdrowia w Warszawie - na podstawie umowy nr ADR.270.166.2019 z dnia 21.08.2019 r. przeprowadziliśmy 21 wizyt monitoringowych oraz kontrolę 65 projektów współfinansowanych ze środków Unii europejskiej.",
                      "Polska Agencja Rozwoju Przedsiębiorczości w Warszawie - na podstawie umowy nr 78/BZP/DRK/2020 z dnia 15.12.2020 r. przeprowadziliśmy  11 doraźnych audytów funkcjonowania podmiotów w Bazie Usług Rozwojowych (BUR).",
                      "Polska Agencja Rozwoju Przedsiębiorczości w Warszawie - na podstawie umowy nr 79/BZP/DRK/2020 z dnia 15.12.2020 r. przeprowadziliśmy 178 audytów usług rozwojowych w Bazie Usług Rozwojowych.",
                      "Ministerstwo Rodziny, Pracy i Polityki Społecznej w Warszawie - na podstawie umowy nr 30/DWF/PN/2018/2019 z dnia 05.02.2019 r. przeprowadziliśmy 47 wizyt monitoringowych oraz 104  kontrole projektów współfinansowanych ze środków Unii europejskiej.",
                      "Centrum Projektów Polska Cyfrowa w Warszawie - na podstawie umowy nr ZP/4/2017 z dnia 30.03.2017 r. przeprowadziliśmy 22 kontrole współfinansowanych ze środków Unii Europejskiej.",
                      "Centrum Projektów Polska Cyfrowa w Warszawie - na podstawie umowy nr ZP/3/2018 z dnia 09.10.2018 r. przeprowadziliśmy 54 kontrole współfinansowanych ze środków Unii Europejskiej.",
                    ]
                },
            ]
        },
      ]
    }),
  }
  </script>
  